import { MentionIcon } from '@/components/common/Icons';
import type { CommentInputProps } from '@/features/comments/types';
import { type FormEvent, useState } from 'react';

export const CommentInput = ({
	onSubmit,
	placeholder = 'Your comment',
	initialValue = '',
	author,
}: CommentInputProps) => {
	const [comment, setComment] = useState(initialValue);

	const handleSubmit = (e: FormEvent) => {
		e.preventDefault();
		if (comment.trim()) {
			onSubmit(comment);
			setComment('');
		}
	};

	return (
		<form onSubmit={handleSubmit} className="flex gap-3 items-start">
			<div className="w-[32px] h-[32px] rounded-full shrink-0">
				<img
					src={author.userAvatar}
					alt={author.userFullName}
					className="w-full h-full rounded-full object-cover"
				/>
			</div>
			<div className="flex-1 relative">
				<input
					type="text"
					value={comment}
					onChange={(e) => setComment(e.target.value)}
					placeholder={placeholder}
					className="w-full px-4 py-[10px] rounded-full bg-[#F8F8F8] focus:outline-none focus:ring-1 focus:ring-[#5B9D48] text-[14px] text-[#2D2D2D] placeholder-[#8F8F8F] pr-10"
				/>
				<button
					type="button"
					className="absolute right-4 top-1/2 -translate-y-1/2 text-[#8F8F8F] hover:text-[#5B9D48] cursor-pointer"
				>
					<MentionIcon />
				</button>
			</div>
		</form>
	);
};
